module.exports = __webpack_public_path__ + "img/history-active-v2.09afb067.svg";